import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PERMISSION_STATE } from '../../utils/agencyPermissions';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';
import Tooltip from './Tooltip';
import css from './PermissionBadge.css';

const translationPrefix = 'STATIC.TOOLTIPS.PERMISSION_BADGE';

export const PERMISSION_BADGE_ENTITY = {
    PARTNER_CONFIGURATION: 'partnerConfiguration',
    LINK: 'link',
};

const NO_ACCESS_KEY_BY_ENTITY = {
    [PERMISSION_BADGE_ENTITY.PARTNER_CONFIGURATION]: `${translationPrefix}.NO_ACCESS_PARTNER_CONFIGURATION`,
    [PERMISSION_BADGE_ENTITY.LINK]: `${translationPrefix}.NO_ACCESS_LINK`,
};

const STATE_CONFIG = {
    [PERMISSION_STATE.EDIT]: {
        icon: 'check',
        variant: IconVariants.SUCCESS,
        tooltipKey: `${translationPrefix}.PERMISSION_EDIT`,
    },
    [PERMISSION_STATE.VIEW]: {
        icon: 'eye',
        variant: IconVariants.ACTIVE,
        tooltipKey: `${translationPrefix}.PERMISSION_VIEW_ONLY`,
    },
    [PERMISSION_STATE.NO_PERMISSION]: {
        icon: 'ban',
        variant: IconVariants.ERROR,
    },
};

const PermissionBadge = ({
    state,
    name,
    size = IconSizes.X_SMALL,
    truncate = false,
    className = '',
    entity = PERMISSION_BADGE_ENTITY.PARTNER_CONFIGURATION,
}) => {
    const config = STATE_CONFIG[state];
    if (!config) {
        return null;
    }
    const tooltipKey = state === PERMISSION_STATE.NO_PERMISSION ? NO_ACCESS_KEY_BY_ENTITY[entity] : config.tooltipKey;
    return (
        <span className={classNames(css.permissionBadge, className)}>
            <Tooltip titleTranslationKey={tooltipKey}>
                <Icon
                    name={config.icon}
                    size={size}
                    variant={config.variant}
                    interactive={false}
                    className={css.icon}
                />
            </Tooltip>
            <Tooltip title={name}>
                <span className={classNames(css.name, { [css.truncated]: truncate })}>{name}</span>
            </Tooltip>
        </span>
    );
};

PermissionBadge.propTypes = {
    state: PropTypes.oneOf(Object.values(PERMISSION_STATE)).isRequired,
    name: PropTypes.string,
    size: PropTypes.oneOf(Object.values(IconSizes)),
    truncate: PropTypes.bool,
    className: PropTypes.string,
    entity: PropTypes.oneOf(Object.values(PERMISSION_BADGE_ENTITY)),
};

export default PermissionBadge;
